import { useTranslation } from "react-i18next";
import { withForm } from "@/components/form/form";
import { PageSection } from "@/components/section/SectionBlocks";
import { profileToForm } from "./companyForm";

/** Core identity, mission & values, company details, products & services. */
export const IdentitySections = withForm({
  defaultValues: profileToForm(null),
  render: function IdentitySectionsRender({ form }) {
    const { t } = useTranslation("adminCompany");
    return (
      <>
        <PageSection title={t("identity.title")} description={t("identity.description")}>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <form.AppField name="companyName">
              {(field) => (
                <field.TextField label={t("fields.companyName")} required placeholder={t("placeholders.companyName")} />
              )}
            </form.AppField>
            <form.AppField name="industry">
              {(field) => <field.TextField label={t("fields.industry")} placeholder={t("placeholders.industry")} />}
            </form.AppField>
          </div>
          <form.AppField name="website">
            {(field) => <field.TextField label={t("fields.website")} placeholder={t("placeholders.website")} />}
          </form.AppField>
          <form.AppField name="description">
            {(field) => (
              <field.TextareaField
                label={t("fields.description")}
                rows={3}
                placeholder={t("placeholders.description")}
              />
            )}
          </form.AppField>
        </PageSection>

        <PageSection title={t("mission.title")}>
          <form.AppField name="mission">
            {(field) => (
              <field.TextareaField label={t("fields.mission")} rows={3} placeholder={t("placeholders.mission")} />
            )}
          </form.AppField>
          <form.AppField name="values">
            {(field) => (
              <field.TextareaField label={t("fields.values")} rows={3} placeholder={t("placeholders.values")} />
            )}
          </form.AppField>
        </PageSection>

        <PageSection title={t("details.title")}>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <form.AppField name="foundedYear">
              {(field) => (
                <field.TextField label={t("fields.foundedYear")} placeholder={t("placeholders.foundedYear")} />
              )}
            </form.AppField>
            <form.AppField name="headquarters">
              {(field) => (
                <field.TextField label={t("fields.headquarters")} placeholder={t("placeholders.headquarters")} />
              )}
            </form.AppField>
            <form.AppField name="employeeCount">
              {(field) => (
                <field.TextField label={t("fields.employeeCount")} placeholder={t("placeholders.employeeCount")} />
              )}
            </form.AppField>
          </div>
        </PageSection>

        <PageSection title={t("products.title")}>
          <form.AppField name="productsServices">
            {(field) => (
              <field.TextareaField
                label={t("fields.productsServices")}
                rows={4}
                placeholder={t("placeholders.productsServices")}
              />
            )}
          </form.AppField>
        </PageSection>
      </>
    );
  },
});
